import TimeUnit from "../units/TimeUnit";

export default class DateHelper {
	public static secondsToUnit(value: number, toUnit: TimeUnit): number {
		switch (toUnit) {
			case TimeUnit.MILLISECOND:
				return value * 1000;
			case TimeUnit.SECOND:
				return value;
			case TimeUnit.MINUTE:
				return value / 60;
			case TimeUnit.HOUR:
				return value / 60 / 60;
			case TimeUnit.DAY:
				return value / 60 / 60 / 24;
			case TimeUnit.MONTH:
				return value / 60 / 60 / 24 / 30;
			case TimeUnit.YEAR:
				return value / 60 / 60 / 24 / 30 / 365;
		}
	}

	public static unitToSeconds(value: number, fromUnit: TimeUnit) {
		switch (fromUnit) {
			case TimeUnit.MILLISECOND:
				return value / 1000;
			case TimeUnit.SECOND:
				return value;
			case TimeUnit.MINUTE:
				return value * 60;
			case TimeUnit.HOUR:
				return value * 60 * 60;
			case TimeUnit.DAY:
				return value * 60 * 60 * 24;
			case TimeUnit.MONTH:
				return value * 60 * 60 * 24 * 30;
			case TimeUnit.YEAR:
				return value * 60 * 60 * 24 * 30 * 365;
		}
	}

	public static unitToUnit(value: number, fromUnit: TimeUnit, toUnit: TimeUnit): number {
		return this.secondsToUnit(this.unitToSeconds(value, fromUnit), toUnit);
	}

	public static formatTime(millis: number, showMillis: boolean = false): string {
		let result: Array<string> = [];
		let value: number = Math.max(millis, 0);

		if (Number.isNaN(millis)) {
			value = 0;
		}

		let days: number = Math.floor(value / this.unitToUnit(1, TimeUnit.DAY, TimeUnit.MILLISECOND))
		value %= this.unitToUnit(1, TimeUnit.DAY, TimeUnit.MILLISECOND);
		if (days > 0) {
			result.push(days + TimeUnit.DAY);
		}

		let hours: number = Math.floor(value / this.unitToUnit(1, TimeUnit.HOUR, TimeUnit.MILLISECOND))
		value %= this.unitToUnit(1, TimeUnit.HOUR, TimeUnit.MILLISECOND);
		if (hours > 0) {
			result.push(hours + TimeUnit.HOUR);
		}

		let minutes: number = Math.floor(value / this.unitToUnit(1, TimeUnit.MINUTE, TimeUnit.MILLISECOND))
		value %= this.unitToUnit(1, TimeUnit.MINUTE, TimeUnit.MILLISECOND);
		if (minutes > 0) {
			result.push(minutes + TimeUnit.MINUTE);
		}

		let seconds: number = Math.floor(value / this.unitToUnit(1, TimeUnit.SECOND, TimeUnit.MILLISECOND))
		value %= this.unitToUnit(1, TimeUnit.SECOND, TimeUnit.MILLISECOND);
		if (seconds > 0) {
			result.push(seconds + TimeUnit.SECOND);
		}

		return result.join(" ");
	}

	public static currentDate(): Date {
		let currentDate: Date = new Date();
		currentDate.setHours(0, 0, 0, 0);
		return currentDate;
	}

	public static buildDateString(date: Date): string {
		return date.getFullYear() + '-' + (((date.getMonth() + 1) < 10) ? '0' : '') +
			(date.getMonth() + 1) + '-' + ((date.getDate() < 10) ? '0' : '') + date.getDate();
	};

	public static buildTimestampString(date: Date, language: string): string {
		switch (language) {
			case "de":
				return DateHelper.pad(date.getDate(), 2) + '.' +
					DateHelper.pad(date.getMonth() + 1, 2) + '.' +
					date.getFullYear() + " " +
					DateHelper.pad(date.getHours(), 2) + ":" +
					DateHelper.pad(date.getMinutes(), 2) + ":" +
					DateHelper.pad(date.getSeconds(), 2);
			default:
				return date.getFullYear() + '-' +
					DateHelper.pad(date.getMonth() + 1, 2) + '-' +
					DateHelper.pad(date.getDate(), 2) + " " +
					DateHelper.pad(date.getHours(), 2) + ":" +
					DateHelper.pad(date.getMinutes(), 2) + ":" +
					DateHelper.pad(date.getSeconds(), 2);
		}
	};

	public static pad(value: number, size: number) {
		let result: string = value.toString();

		while (result.length < size) {
			result = "0" + result;
		}

		return result;
	}

	public static getMonthKey(month: number): string {
		switch (month) {
			case 0:
				return "date.month.january";
			case 1:
				return "date.month.february";
			case 2:
				return "date.month.march";
			case 3:
				return "date.month.april";
			case 4:
				return "date.month.may";
			case 5:
				return "date.month.june";
			case 6:
				return "date.month.july";
			case 7:
				return "date.month.august";
			case 8:
				return "date.month.september";
			case 9:
				return "date.month.october";
			case 10:
				return "date.month.november";
			case 11:
				return "date.month.december";
		}

		return "";
	}

	public static getDayKey(day: number): string {
		switch (day) {
			case 0:
				return "date.day.sunday";
			case 1:
				return "date.day.monday";
			case 2:
				return "date.day.tuesday";
			case 3:
				return "date.day.wednesday";
			case 4:
				return "date.day.thursday";
			case 5:
				return "date.day.friday";
			case 6:
				return "date.day.saturday";
		}

		return "";
	}
}